// extracted by mini-css-extract-plugin
module.exports = {"point":"point-2RQX4","link":"link-_LgX5","airportName":"airportName-SNEQP","terminal":"terminal-1ky1G"};